<!--
 * @Description: table&detail
 * @Date: 2019-11-05 19:51:36
 -->
<template>
  <div class="table-box">
    <!-- 列表 -->
    <div v-show="!showBox">
      <!-- 一级tab -->
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
        v-if="content.length > 1"
      >
        <el-tab-pane
          :label="v.name"
          :name="v.name"
          isDisabled
          v-for="(v, k) in content"
          :key="k"
        />
      </el-tabs>
      <!-- 二级tab -->
      <el-radio-group
        v-model="childActiveIndex"
        @change="handleChildClick"
        v-if="content[activeIndex].childMenu.length > 1"
        style="margin-bottom: 30px;display:block;text-align:left;"
      >
        <el-radio-button
          :label="k"
          :name="v.name || ''"
          v-for="(v, k) in content[activeIndex].childMenu"
          :key="k"
        >
          {{ v.name || '' }}
        </el-radio-button>
      </el-radio-group>
      <slot
        name="search"
        v-bind="{
          handleSearch: handleSearch,
          searchItem: searchItem,
          moreBtnArr: moreBtnArr,
          defaultQuery: defaultQuery,
          query: test
        }"
      >
        <template v-show="!fromJump">
          <component
            v-if="searchComponent && searchComponent !== 'lSearch'"
            ref="search"
            @search="handleSearch"
            :is="searchComponent"
            :searchItem="searchItem"
            :moreBtnArr="moreBtnArr"
            :query="test"
            :defaultQuery="defaultQuery"
          />
        </template>
      </slot>

      <!-- 提示信息 start -->
      <slot name="top-alert"></slot>
      <!-- 提示信息 ended -->
      <!--列表-->
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        :empty-text="tips"
        style="width: 100%;border-left:1px solid #EBEEF5;"
        :stripe="true"
        :highlight-current-row="false"
        :height="$attrs.height || undefined"
        ref="table"
        :row-key="$attrs.rowKey"
        :span-method="$attrs.spanMethod"
        v-on="$listeners"
      >
        <template
          v-for="(v, k) in content[activeIndex].childMenu[childActiveIndex]
            .fields"
        >
          <el-table-column
            v-if="v.type === 'expand'"
            type="expand"
            :key="k - 4"
            :label="v.label"
          >
            <template slot-scope="{ row, column, $index }">
              <template v-if="v.render">
                <myrender
                  :row="row"
                  :column="column"
                  :index="k"
                  :no="$index"
                  :render="v.render || null"
                />
              </template>
              <template v-else>
                <tableForm :data="{ row, column: v }" />
              </template>
            </template>
          </el-table-column>
          <el-table-column
            :key="k - 1"
            v-else-if="v.type === 'expandOrder'"
            type="expand"
          >
            <template slot-scope="{ row }">
              <tableFormOrder :data="{ row, column: v }" />
            </template>
          </el-table-column>
          <el-table-column
            :key="k - 2"
            v-else-if="v.type === 'index'"
            type="index"
            align="center"
            label="序号"
            :width="v.width || ''"
          />
          <el-table-column
            v-else-if="v.type === 'selection'"
            :reserve-selection="v.reserve"
            type="selection"
            :prop="$attrs.rowKey"
            :index="k"
            :width="v.width || '40px'"
            :selectable="
              v.selectable ||
                function() {
                  return true;
                }
            "
            :key="k - 3"
          ></el-table-column>
          <el-table-column
            v-else
            :prop="v.prop"
            :label="v.label"
            :width="v.width || ''"
            :formatter="v.formatter"
            :show-overflow-tooltip="
              v.showToolTip !== undefined ? v.showToolTip : true
            "
            :key="k"
            :align="v.align || 'center'"
          >
            <template #header="{column,$index}" v-if="v.headerRender">
              <myrender
                :row="null"
                :column="column"
                :index="k"
                :no="$index"
                :render="v.headerRender || null"
              />
            </template>
            <template slot-scope="scope">
              <template v-if="v.render">
                <myrender
                  :row="scope.row"
                  :column="scope.column"
                  :index="k"
                  :no="scope.$index"
                  :render="v.render || null"
                />
              </template>
              <template v-else>
                <span
                  :style="v.style && v.style(scope)"
                  class="cell el-tooltip"
                >
                  {{
                    !v.render
                      ? v.formatter
                        ? v.formatter(
                            scope.row,
                            scope.column,
                            scope.row[(scope.column || {}).property]
                          )
                        : scope.row[(scope.column || {}).property] || '-'
                      : ''
                  }}
                </span>
              </template>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div
        v-if="propDate && propDate.showFooter"
        class="table-render-slot-footer"
        v-html="propDate.footer"
      ></div>

      <!--批量操作start-->
      <el-row :gutter="12" type="flex" style="padding: 15px 0">
        <slot
          name="batchAction"
          v-bind="{ tableRef: $refs.table, tableResp }"
        ></slot>
      </el-row>
      <!--批量操作ended-->
      <el-pagination
        v-if="totalElements !== void 0 && !hidePagination"
        :small="true"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNo"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
      />
    </div>
    <div class="component-box" v-if="showBox">
      <el-button
        @click="closeDetail"
        type="text"
        class="newBackBtn"
        icon="el-icon-arrow-left"
      >
        返回
      </el-button>
      <component :is="partName" :config="partDate" :propDate="partProps" />
    </div>
    <!--    对话框-->
    <el-dialog
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      class="ee"
      :before-close="handleDialogClose"
      :title="dialogTitle"
    >
      <div slot="title" v-if="!dialogTitle"></div>
      <component :is="dialogName" :config="dialogDate" :propDate="partProps" />
      <div slot="footer" v-if="dialogFooter">
        <!--        <el-button @click="dialogVisible = false">取 消</el-button>-->
        <el-button type="primary" @click="dialogVisible = false">
          确 定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tableRenderMixin from './tableRenderMixin';
export default {
  mixins: [tableRenderMixin]
};
</script>
<style lang="scss" scoped>
.hidden-detail {
  float: right;
  width: 1em;
  font-size: 25px;
}
</style>
